module.exports = __webpack_public_path__ + "static/media/clock.7f27409a.svg";